import { DataQueryField } from './data-query-field.model';
export class DataQueryTransformationField {

    // Properties
	fieldId: number;
	categoryId: number;
	position: number;
	sql: string;

    // Constructor
    constructor(field?: DataQueryField) {
        if (field) {
            this.fieldId = field.ID;
            this.categoryId = field.CategoryID;
        }
    }
}